import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import ModuleCard from "../../../components/common/card";
import { option_category_obj } from "../../../service/option";

import ImgHeartbeat from "../../../images/common/heartbeat.png";
import ImgSugar from "../../../images/common/sugar.png";
import ImgWeight from "../../../images/common/weight.png";
import ImgUncomfortable from "../../../images/common/uncomfortable.png";
import ImgHealth from "../../../images/common/health.png";

export default function MemberRecord() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "記錄" },
  ];
  const cardData = [
    {
      title: option_category_obj.record.heartbeat.label,
      img: ImgHeartbeat,
      url: `/member/record/${option_category_obj.record.heartbeat.value}`,
    },
    {
      title: option_category_obj.record.sugar.label,
      img: ImgSugar,
      url: `/member/record/${option_category_obj.record.sugar.value}`,
    },
    {
      title: option_category_obj.record.weight.label,
      img: ImgWeight,
      url: `/member/record/${option_category_obj.record.weight.value}`,
    },
    {
      title: option_category_obj.record.uncomfortable.label,
      img: ImgUncomfortable,
      url: `/member/record/${option_category_obj.record.uncomfortable.value}`,
    },
    {
      title: option_category_obj.record.health.label,
      img: ImgHealth,
      url: `/member/record/${option_category_obj.record.health.value}`,
    },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "記錄" }} />

      <ModuleCard data={cardData} />
    </>
  );
}
